import { CSSProperties } from 'react';

export const containerStyle: CSSProperties = {
  width: '100%',
  maxWidth: 1360,
  margin: '0 auto',
};

export const headerStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 24,
};

export const cardStyle: CSSProperties = {
  borderRadius: 16,
  border: '1px solid #e2e8f0',
  boxShadow: 'none',
};

export const dropZoneBaseStyle: CSSProperties = {
  border: '2px dashed #d9d9d9',
  borderRadius: 12,
  padding: 40,
  textAlign: 'center',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  background: '#fafafa',
};

export const dropZoneActiveStyle: CSSProperties = {
  ...dropZoneBaseStyle,
  borderColor: '#1E6DF6',
  background: 'rgba(30, 109, 246, 0.05)',
};

export const dropZoneSuccessStyle: CSSProperties = {
  ...dropZoneBaseStyle,
  borderColor: '#00a87e',
  background: 'rgba(0, 168, 126, 0.05)',
  cursor: 'default',
};

export const dropZoneErrorStyle: CSSProperties = {
  ...dropZoneBaseStyle,
  borderColor: '#e23b4a',
  background: 'rgba(226, 59, 74, 0.05)',
  cursor: 'default',
};

export const fileInfoStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
  padding: '12px 0',
};

export const templateSectionStyle: CSSProperties = {
  marginTop: 16,
  padding: '12px 16px',
  background: '#f5f5f5',
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const previewHeaderStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 16,
};

export const statusBadgeStyle = (
  status: 'idle' | 'parsing' | 'success' | 'error',
): CSSProperties => {
  const colors: Record<string, { bg: string; text: string }> = {
    idle: { bg: '#f5f5f5', text: '#8c8c8c' },
    parsing: { bg: 'rgba(30, 109, 246, 0.08)', text: '#1E6DF6' },
    success: { bg: 'rgba(0, 168, 126, 0.08)', text: '#00a87e' },
    error: { bg: 'rgba(226, 59, 74, 0.08)', text: '#e23b4a' },
  };
  const color = colors[status] || colors.idle;
  return {
    padding: '2px 12px',
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 600,
    background: color.bg,
    color: color.text,
    display: 'inline-block',
  };
};

export const submitBarStyle: CSSProperties = {
  position: 'sticky',
  bottom: 0,
  background: '#fff',
  padding: '16px 24px',
  borderTop: '1px solid #f0f0f0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: '0 0 12px 12px',
  zIndex: 10,
};

export const tabToolbarStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 20,
  padding: '12px 16px',
  background: '#fafafa',
  borderRadius: 8,
  border: '1px solid #f0f0f0',
};

export const crudActionsStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
};

export const editableCellInputStyle: CSSProperties = {
  width: '100%',
  fontSize: 13,
};
